import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
  selector: 'app-table-selection-cell',
  imports: [MatCheckbox],
  templateUrl: './table-selection-cell.component.html',
  styleUrl: './table-selection-cell.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    'class': 'table-selection-cell',
    '[class.table-selection-cell-row]': 'row',
    '[class.table-selection-cell-checked]': 'checked',
    '[class.table-selection-cell-indeterminate]': 'indeterminate',
    '[class.table-selection-cell-disabled]': 'disabled'
  }
})
export class TableSelectionCellComponent {

  @Input() checked: boolean = false;
  @Input() indeterminate: boolean = false;
  @Input() disabled: boolean = false;
  @Input() ariaLabel: string = '';
  @Input() row: boolean = false;

  @Output() toggled: EventEmitter<void> = new EventEmitter<void>();

  protected toggle(): void {
    if (!this.disabled) {
      this.toggled.emit();
    }
  }

  protected toggleWithEnter(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.toggle();
  }
}
